import { useDispatch, useSelector } from 'react-redux';
import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useUpdateFolderMutation } from '../../../../queries';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';
import { Dialog } from 'primereact/dialog'

function UpdateFolder({ item,currentFolder }) {
    const { t } = useTranslation();
    const { formState: { errors }, handleSubmit, register } = useForm({ item });
    const dispatch = useDispatch();

    const openDialog = useSelector((state) => state.global.openDialog);

    const { mutate: updateFolder, isLoading } = useUpdateFolderMutation();
    const [folderName, setFolderName] = useState(item.folder_name)

    const onSubmit = (data) => {
        updateFolder({ folderId: currentFolder.id, data });
    };

    return (
        <>
            <Dialog header={t('media.media_folder_updating')}
                visible={openDialog.updateFolder}
                onHide={() => { dispatch(toggleDialog("updateFolder")) }}
                breakpoints={{ '960px': '95vw' }}
                style={{ width: '25vw' }}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="my-5 px-4">
                        {/* <label htmlFor="">Folder Name</label> */}
                        <input
                            {...register("name", { required: t('media.media_folder_name_required') })}
                            aria-invalid={errors.name ? "true" : "false"}
                            className={errors.name ? 'form-control is-invalid fs-4' : 'form-control fs-5'}
                            placeholder={t('media.media_folder_name_placeholder')} value={folderName} onChange={(e) => setFolderName(e.value)}
                        />
                        {errors.name && <p className='fv-plugins-message-container invalid-feedback'>{errors.name?.message}</p>}
                    </div>
                    <div className="col-12 text-center d-flex  align-items-end  justify-content-center py-4 border-top border-gray">
                        <button type="reset" className="btn btn-label-secondary me-3" data-bs-dismiss="modal" aria-label="Close" onClick={() => dispatch(toggleDialog("updateFolder"))}>
                            {t('buttons.cancel')}
                        </button>
                        <button type="submit" className="btn btn-primary me-3" disabled={isLoading}>{t('buttons.update')}</button>
                    </div>
                </form>
            </Dialog>
        </>
    )
}

export default UpdateFolder